import React from "react";
import ReactDOMServer from "react-dom/server";
import { Modal, Button } from "react-bootstrap";
import LeaveFormPrint from "./LeaveFormPrint";

// Two slips per A4 page - the reference paper form (Working_Files photo,
// 2026-09-07) only shows a handful of short fields, printing one per page
// wastes most of the sheet. Pairs are chunked here and each pair becomes one
// physical page (page-break-after between pairs, none after the last).
const chunkPairs = (items) => {
  const pairs = [];
  for (let i = 0; i < items.length; i += 2) pairs.push(items.slice(i, i + 2));
  return pairs;
};

// Shown right after a successful Mark Leave save (single or bulk) - one slip
// per employee who actually got marked (skipped ones never reach here, see
// LeaveManagementPage.jsx's handleSave). Reuses this project's established
// print-popup pattern (StockDocumentPrintModal.jsx: window.open("", "_blank")
// -> ReactDOMServer.renderToStaticMarkup -> document.write -> window.print())
// rather than a new print dependency - same on-screen preview / print-popup
// component, one template.
const LeaveFormPrintModal = ({ show, onClose, slips = [] }) => {
  const handlePrint = () => {
    const pairs = chunkPairs(slips);
    const bodyHtml = pairs
      .map((pair, idx) => {
        const pageSlips = pair
          .map(
            (slip, slipIdx) =>
              `<div style="${slipIdx === 1 ? "margin-top: 6mm; border-top: 1px dashed #999; padding-top: 6mm;" : ""}">${ReactDOMServer.renderToStaticMarkup(
                <LeaveFormPrint {...slip} />
              )}</div>`
          )
          .join("");
        return `<div style="${idx > 0 ? "page-break-before: always;" : ""}">${pageSlips}</div>`;
      })
      .join("");

    const win = window.open("", "_blank", "width=900,height=1000");
    if (!win) return;
    win.document.write(
      `<html><head><title>Employee Leave Forms</title>` +
        `<style>@page { size: A4; margin: 10mm; } html,body { margin:0; padding:0; } body { width: 190mm; }</style>` +
        `</head>` +
        `<body onload="window.print();window.close();">${bodyHtml}</body></html>`
    );
    win.document.close();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Leave Form{slips.length > 1 ? "s" : ""} - {slips.length} employee{slips.length === 1 ? "" : "s"}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#e9ecef" }}>
        {slips.map((slip, idx) => (
          <div key={idx} className="mb-3" style={{ border: "1px solid #ccc" }}>
            <LeaveFormPrint {...slip} />
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
        <Button variant="primary" onClick={handlePrint}>Print</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LeaveFormPrintModal;
